// extracted by mini-css-extract-plugin
export default {"container":"SongsPageNavigation_container__gIYgd"};